import { ENABLE_MAGIC_LINK_BUTTON, SHOW_MAGIC_LINK_MODAL } from './types';

export const showMagicLinkModal = (showMagicLinkModal, email = '') => ({
  type: SHOW_MAGIC_LINK_MODAL,
  payload: { showMagicLinkModal, email },
});

export const enableSubmit = (submitEnabled) => ({
  type: ENABLE_MAGIC_LINK_BUTTON,
  payload: { submitEnabled },
});
